













import VButton from '@/components/VButton.vue'
import { defineComponent } from '@vue/composition-api'
import { useStore } from '@/store'

export default defineComponent({
  name: 'VControls',

  components: {
    VButton
  },

  setup() {
    const { stopRoute, state } = useStore()

    return {
      stopRoute,
      state
    }
  }
})
